import React from 'react';
import styles from './SecondBlock.module.scss';
import { ReactComponent as WaveIcon } from '../../images/wave.svg';
import { ReactComponent as StarIcon } from '../../images/star.svg';
// import { ReactComponent as BannerBgIcon } from '../../images/banner_bg.svg';
import { ReactComponent as BannerRabbitIcon } from '../../images/banner_rabbit.svg';
import { ReactComponent as BannerBilletIcon } from '../../images/banner_billet.svg';
import { ReactComponent as BannerGiftIcon } from '../../images/banner_gift.svg';
import { ReactComponent as BannerEggIcon } from '../../images/banner_egg.svg';
import ClassExample from '../../images/class_example.png';

const STEPS = [
  {
    title: 'Ребенок не&nbsp;заскучает',
    // eslint-disable-next-line no-irregular-whitespace
    description: `В&nbsp;нужное время дети подключаются по&nbsp;ссылке&nbsp;&mdash; и&nbsp;отправляются в&nbsp;интерактивное онлайн-приключение с&nbsp;заданиями, тайнами и&nbsp;живым чатом.`,
  },
  {
    title: 'Уроки в&nbsp;прямом эфире и&nbsp;записи',
    // eslint-disable-next-line no-irregular-whitespace
    description: `Заниматься можно с&nbsp;телефона, планшета или компьютера. Если пропустили занятие, его запись будет доступна.`,
  },
  {
    title: 'Комфортный распорядок ',
    // eslint-disable-next-line no-irregular-whitespace
    description: `Занятие длится 40&nbsp;минут&nbsp;&mdash; ребенок увлечется темой и&nbsp;не&nbsp;устанет. Для отработки знаний останутся материалы: распечатки или творческие листы.`,
  },
];

export function SecondBlock() {
  return (
    <div className={styles.root}>
      <WaveIcon className={styles.waveImg} />
      <WaveIcon className={styles.waveImg} />
      <div className={styles.content}>
        <h2 className={styles.title}>Как проходит обучение</h2>
        <div className={styles.exampleWrapper}>
          <img src={ClassExample} alt="Пример обучения" className={styles.exampleImg} />
          <div className={styles.steps}>
            {STEPS.map(({ title, description }, idx) => (
              <div key={title} className={styles.stepWrapper}>
                <StarIcon />
                <div>
                  {/* eslint-disable-next-line react/no-danger */}
                  <p dangerouslySetInnerHTML={{ __html: title }} />
                  {/* eslint-disable-next-line react/no-danger */}
                  <p dangerouslySetInnerHTML={{ __html: description }} />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.bannerWrapper}>
          <BannerGiftIcon className={styles.bannerGift} />
          <div className={styles.banner}>
            <h3 className={styles.bannerTitle}>Плюсы занятий в&nbsp;реальном времени</h3>
            <p className={styles.bannerDescription}>
              Живое общение, командные игры, викторины и&nbsp;соревнования, возможность задавать
              вопросы
            </p>
            <div className={styles.bannerBg} />
            <div className={styles.bannerRabbitWrapper}>
              <BannerRabbitIcon className={styles.bannerRabbit} />
            </div>
          </div>
          <div className={styles.bannerBillet}>
            <p className={styles.billetTitle}>
              За&nbsp;первое занятие&nbsp;+30{' '}
              <span>
                <BannerEggIcon className={styles.bannerEggIcon} />
              </span>
            </p>
            <BannerBilletIcon className={styles.bannerBilletIcon} />
          </div>
        </div>
      </div>
    </div>
  );
}
